import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private headerMenuOpen = new BehaviorSubject<boolean>(false);
  currentheaderMenuOpen = this.headerMenuOpen.asObservable();

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  public isServer(): boolean {
    return isPlatformServer(this.platformId);
  }

  getData(url: string): Promise<any> {
    const getUrl = environment.apiDomain + 'api/' + url;

    if (this.isServer()) {
      process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = '0';
    }

    const headers = {
      'Content-Type': 'application/json; charset=utf-8',
    };

    return this.httpClient
      .get<any>(getUrl, { headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  postData(url: string, body: string): Promise<any> {
    const postUrl = environment.apiDomain + 'api/' + url;

    const headers = {
      'Content-Type': 'application/json',
    };

    return this.httpClient
      .post<any>(postUrl, body, { headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    const body = JSON.stringify(res);
    return body || {};
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  toggleMenuOpen(status: boolean) {
    this.headerMenuOpen.next(status);
  }

  checkForRedirect(url: string) {
    this.getData('redirect?url=' + url).then((x) => {
      let newUrl = JSON.parse(x);
      let statusCode = 301;
      if (newUrl && newUrl !== 'not found') {
        statusCode = 301;
      } else {
        newUrl = '';
      }

      this.router.navigate(['/' + JSON.parse(x)]);
      if (isPlatformServer(this.platformId)) {
        this.router.navigate(['/' + JSON.parse(x)]);
      } else {
        window.location.replace(newUrl);
      }
    });
  }

  escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }

  replaceImageUrlFromEditor(str: string, mode?: string, size?: string) {
    const replace =
      environment.imgFxDomain
        .replace('{mode}', mode ?? 'cdn')
        .replace('{size}', size ?? '') + 'tekstredigerer';
    str = str.replace(
      new RegExp(this.escapeRegExp('../Upload/editor-image'), 'g'),
      replace,
    );

    str = str.replace(
      new RegExp(this.escapeRegExp('Upload/editor-image'), 'g'),
      replace,
    );

    return str;
  }
}
